import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { AssetUIModel, ClientCoreModule, FormField, OptionsLabelPipe, ValueListsService } from '@thehubz/client/core';
import { AnyType } from '@thehubz/shared/model';
import { getBrandMarkeListSEAT, getBrandModelListSEAT } from '../../../../../../../../customer/customer-metadata-config';
import { seatContentDescriptionFields, seatGeneralInformationFields } from '../../../../../../../../customer/seat/seat-form-fields';

@Component({
  selector: 'thehubz-seat-asset-metadata',
  templateUrl: './seat-asset-metadata.component.html',
  styleUrls: ['./seat-asset-metadata.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, ClientCoreModule],
})
export class SeatAssetMetadataComponent implements OnInit {
  @Input() asset!: AssetUIModel;

  assetFieldObject: AnyType = [];
  assetDomains: AnyType[] = [];

  constructor(
    protected valueListsService: ValueListsService,
    private cdr: ChangeDetectorRef,
    private optionsLabel: OptionsLabelPipe,
  ) {}

  ngOnInit(): void {
    const seatDescriptionFields = seatContentDescriptionFields().map((field) => {
      if (field.formFieldName === 'specialFeature') {
        field.fieldLabel = field.fieldLabel.replace('sm', 's-m');
      }
      return field;
    });

    this.assetFieldObject = [...seatGeneralInformationFields(), ...seatDescriptionFields];
    const mediaTypeFieldIndex = this.assetFieldObject.findIndex((fields: FormField) => fields.formFieldName === 'mediaType');
    if (mediaTypeFieldIndex > -1) {
      const mediaTypeField: FormField = this.assetFieldObject[mediaTypeFieldIndex];
      if (Array.isArray(mediaTypeField.options) && mediaTypeField.options.length === 2) {
        const list1 = mediaTypeField.options[0]?.['lists'] ?? [];
        const list2 = mediaTypeField.options[1]?.['lists'] ?? [];
        mediaTypeField.options = [...list1, ...list2];
      }
    }

    this.asset.domains?.forEach((domain: AnyType) => {
      if (domain.brandMarke || domain.brandModel) {
        domain.brandMarke = this.optionsLabel.transform(domain.brandMarke, getBrandMarkeListSEAT());
        domain.brandModel = this.optionsLabel.transform(domain.brandModel, getBrandModelListSEAT(domain.brandMarke?.toLowerCase() || ''));
        this.assetDomains.push(domain);
      }
      this.cdr.detectChanges();
    });
  }

  showLabelCheck(formField: AnyType) {
    let showLabel = false;
    if (formField?.fieldAssociated && formField?.fieldAssociated.length > 0) {
      formField.fieldAssociated.forEach((associatedFields: string) => {
        if (this.asset[associatedFields] || (this.asset.customFields && this.asset.customFields[associatedFields])) {
          showLabel = true;
        }
      });
    }
    return showLabel;
  }
}
